import IAnalyticsAction from "../IAnalyticsAction";
import {getType} from "typesafe-actions";
import {gameInit, sendReport, trackAction} from "../../actions";
import gameInitHandler from "./gameInitHandler";
import trackActionHandler from "./trackActionHandler";
import sendReportHandler from "./sendReportHandler";
import {IApplicationState} from "../../..";
import {loadScene} from "../../../routing/actions";
import loadSceneHandler from "./loadSceneHandler";
import {addBonus, addCoins, addLives, addScore, createShortcut} from "../../../player/actions";
import addCoinsHandler from "./addCoinsHandler";
import addLivesHandler from "./addLivesHandler";
import addScoreHandler from "./addScoreHandler";
import addBonusHandler from "./addBonusHandler";
import {completeLevel, startLevel} from "../../../game/actions";
import startLevelHandler from "./startLevelHandler";
import completeLevelHandler from "./completeLevelHandler";
import {
    answerQuestion,
    expireAnswerTimeout,
    leaveFeedback,
    resetAnswerTimer,
    skipQuestion
} from "../../../questions/actions";
import answerQuestionHandler from "./answerQuestionHandler";
import expireAnswerTimeoutHandler from "./expireAnswerTimeoutHandler";
import skipQuestionHandler from "./skipQuestionHandler";
import resetAnswerTimerHandler from "./resetAnswerTimerHandler";
import {closeAds, showAds, watchAds} from "../../../advertisement/actions";
import watchAdsHandler from "./watchAdsHandler";
import showAdsHandler from "./showAdsHandler";
import closeAdsHandler from "./closeAdsHandler";
import {selectCard} from "../../../mini-games/cards/actions";
import selectCardHandler from "./selectCardHandler";
import {selectChest} from "../../../mini-games/chests/actions";
import selectChestHandler from "./selectChestHandler";
import {showDialog} from "../../../dialog-manager/actions";
import showDialogHandler from "./showDialogHandler";
import {showTutorial} from "../../../tutorial/actions";
import showTutorialHandler from "./showTutorialHandler";
import {consume} from "../../../payments/actions";
import purchaseHandler from "./purchaseHandler";
import leaveFeedbackHandler from "./leaveFeedbackHandler";
import createShortcutHandler from "./createShortcutHandler";

export const index: Record<string, (action: any, state: IApplicationState) => IAnalyticsAction | undefined> = {
    [getType(gameInit)]: gameInitHandler,
    [getType(trackAction)]: trackActionHandler,
    [getType(sendReport)]: sendReportHandler,
    [getType(loadScene.request)]: loadSceneHandler,
    [getType(addCoins)]: addCoinsHandler,
    [getType(addLives)]: addLivesHandler,
    [getType(addScore)]: addScoreHandler,
    [getType(addBonus)]: addBonusHandler,
    [getType(startLevel)]: startLevelHandler,
    [getType(completeLevel)]: completeLevelHandler,
    [getType(answerQuestion)]: answerQuestionHandler,
    [getType(expireAnswerTimeout)]: expireAnswerTimeoutHandler,
    [getType(skipQuestion)]: skipQuestionHandler,
    [getType(resetAnswerTimer)]: resetAnswerTimerHandler,
    [getType(selectCard)]: selectCardHandler,
    [getType(selectChest)]: selectChestHandler,
    [getType(watchAds)]: watchAdsHandler,
    [getType(showAds)]: showAdsHandler,
    [getType(closeAds)]: closeAdsHandler,
    [getType(showDialog)]: showDialogHandler,
    [getType(showTutorial.success)]: showTutorialHandler,
    [getType(consume.success)]: purchaseHandler,
    [getType(leaveFeedback)]: leaveFeedbackHandler,
    [getType(createShortcut.request)]: createShortcutHandler,
    [getType(createShortcut.success)]: createShortcutHandler,
    [getType(createShortcut.failure)]: createShortcutHandler,
};